import React from "react";
import { ExerciseEditorProps } from "./exercise-editor-types";
import { WrittenExerciseContent } from "@org/ui";
import { ExerciseType } from "@org/model";
import { Label } from "@org/ui";
import { TextArea } from "@org/ui";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@org/ui";

export const WrittenExerciseEditor: React.FC<ExerciseEditorProps<WrittenExerciseContent>> = ({
  content,
  updateContent
}) => {
  const handleUpdate = (nextData: Partial<WrittenExerciseContent["data"]>) => {
    updateContent({
      ...content,
      data: {
        ...content.data,
        ...nextData
      }
    });
  };

  return (
    <div className="space-y-4">
      <div>
        <Label htmlFor={`correction-${content.id}`}>Correction</Label>
        <TextArea
          id={`correction-${content.id}`}
          value={content.data.correction}
          onChange={(event) => handleUpdate({ correction: event.target.value })}
          placeholder="Optional note on what to look for in the answer"
          className="mt-1 min-h-[100px]"
        />
      </div>

      <div>
        <Label htmlFor={`format-${content.id}`}>Format</Label>
        <Select
          value={content.data.format}
          onValueChange={(value) => handleUpdate({ format: value as "plain" | "markdown" | "html" })}
        >
          <SelectTrigger id={`format-${content.id}`} className="w-full mt-1">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="plain">Plain Text</SelectItem>
            <SelectItem value="markdown">Markdown</SelectItem>
            <SelectItem value="html">HTML</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div>
        <Label htmlFor={`textType-${content.id}`}>Answer Length</Label>
        <Select
          value={content.data.textType}
          onValueChange={(value) => {
            const nextTextType = value as "long" | "short";
            handleUpdate({
              textType: nextTextType,
              exerciseSubtype: nextTextType === "long" ? ExerciseType.LongAnswer : ExerciseType.ShortAnswer
            } as Partial<WrittenExerciseContent["data"]>);
          }}
        >
          <SelectTrigger id={`textType-${content.id}`} className="w-full mt-1">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="short">Short</SelectItem>
            <SelectItem value="long">Long</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};
